import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './Navigation.module.css';
import messages from './Navigation.messages';
import classNames from 'classnames';
import DropdownMenu from './DropdownMenu';
import useOnClickOutside from 'use-onclickoutside';
import IwMedia from '../../iwMedia/IwMedia';
import { useLocation } from 'react-router-dom';

const MenuAction = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { key: locationKey } = useLocation();
    const menuRef = useRef(null);

    useOnClickOutside(menuRef, () => setIsOpen(false));
    const toggleMenu = () => setIsOpen(!isOpen);

    useEffect(() => {
        setIsOpen(false);
    }, [locationKey]);

    return (
        <>
            <div className={styles.menuContainer} ref={menuRef}>
                <button
                    data-testid="dropdown-menu-toggle"
                    className={styles.rightAction}
                    onClick={toggleMenu}
                >
                    <FormattedMessage {...messages.menu} />{' '}
                    <div
                        className={classNames(
                            styles.navIcon,
                            isOpen && styles.closeIcon
                        )}
                    >
                        <span className={styles.menuIconLine} />
                        <span className={styles.menuIconLine} />
                        <span className={styles.menuIconLine} />
                        <span
                            className={classNames(
                                styles.menuIconLine,
                                styles.animatedLine
                            )}
                        />
                        <span
                            className={classNames(
                                styles.menuIconLine,
                                styles.animatedLine
                            )}
                        />
                    </div>
                </button>
                <DropdownMenu isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>
            <IwMedia to="medium">
                <div
                    data-testid="mobile-nav-underlay"
                    className={classNames(
                        styles.mobileMenuUnderlay,
                        !isOpen && styles.hideUnderlay
                    )}
                />
            </IwMedia>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default MenuAction;
